module.exports = __webpack_public_path__ + "img/ch-window-res.6fa23363.jpg";